export default {
  PostedState: 'Trạng thái ghi sổ',
  PostedDate: 'Ngày hạch toán',
  NoData: 'Không có dữ liệu',
  NotFoundData: 'Không tìm thấy dữ liệu phù hợp',
  EmptyData: 'Chưa có dữ liệu',
  Search: 'Tìm kiếm...',
  FeaturesIsDeveloping: 'Tính năng đang phát triển',
  TotalAmount: 'Tổng tiền',
  GeneralInfo: 'Thông tin chung',
  Guide: 'Hướng dẫn',
  Help: 'Trợ giúp',
  Email: 'Email',
  Other: 'Khác',
  CustomizeLayout: 'Tùy chỉnh giao diện',
  VoucherReference: 'CT tham chiếu',
  VoucherReferenceTooltip: 'Chứng từ tham chiếu',
  DefaultCategory: 'Lấy lại danh mục ngầm định',
  ConvertCategory: 'Phục hồi chỉ tiêu từ MISA Panda Desktop',
  TextButton: {
    ConnectNow: 'Kết nối ngay',
    Connected: 'Đã kết nối',
    Disconnect: 'Ngừng kết nối',
    Disconnect2: 'Ngắt kết nối', // pntoan 28.2.2024 Vẫn là chức năng disconnect nhưng text khác
    BatchExecution: 'Thực hiện hàng loạt',
    Filter: 'Lọc',
    Guide: 'Hướng dẫn',
    Shortcut: 'Phím tắt',
    Add: 'Thêm',
  },
  Text: {
    ViewHelpHere: 'Xem hướng dẫn tại đây',
  },
  Command: {
    Add: 'Thêm',
    Edit: 'Sửa',
    Postpone: 'Hoãn',
    Update: 'Cập nhật',
    Delete: 'Xóa',
    DeleteField: 'Xóa thông tin',
    Duplicate: 'Nhân bản',
    More: 'Thêm nữa...',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi',
    Save: 'Lưu|Cất',
    SaveNew: 'Lưu & Thêm',
    Close: 'Đóng',
    Hide: 'Ẩn',
    Help: 'Giúp',
    Cancel: 'Hủy',
    SignCancel: 'Hủy bỏ',
    Sign: 'Ký duyệt',
    SignMore: 'Ký thêm',
    RefuseSign: 'Từ chối ký',
    Revoke: 'Thu hồi',
    Accept: 'Đồng ý',
    SaveAndNew: 'Lưu và thêm mới',
    Confirm: 'Xác nhận',
    NotConfirm: 'Không xác nhận',
    Export: 'Xuất khẩu',
    Finish: 'Hoàn thành',
    Load: 'Nạp',
    Print: 'In',
    Filter: 'Lọc',
    Refresh: 'Lấy lại dữ liệu',
    Setting: 'Thiết lập',
    Default: 'Mặc định',
    List: 'Danh sách',
    AddDetail: 'Thêm dòng',
    AddDetailShortKey: 'Thêm dòng (F9)',
    Import: 'Nhập khẩu',
    Logout: 'Đăng xuất',
    Next: 'Tiếp theo',
    Back: 'Quay lại',
    Move: 'Di chuyển',
    Minimize: 'Thu gọn',
    CreateFormular: 'Lập công thức',
  },
  List: {
    SearchEmptyText: 'Tìm kiếm',
  },
  /**
   * Đoạn này tạm thời vẫn để viết thường vì chưa care được hết vùng ảnh hưởng
   * ndhieu3 20.04.2023
   */
  module: {
    employee: 'Nhân viên',
    employeeType: 'Loại cán bộ',
    payrollItem: 'Khoản lương',
    inventoryItem: 'Vật tư',
    toolList: 'Công cụ dụng cụ',
    buPlanWithDraw: 'Rút dự toán tiền gửi',
    bUTransfer: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    accountingObject: 'Cán bộ',
    diDepartment: 'Phòng/ban',
    account: 'Tài khoản',
    currency: 'Loại tiền',
    baWithdraw: 'Chi tiền gửi',
    inventoryCategory: 'Loại vật tư/CCDC',
    diStock: 'Kho',
    budgetPlan: 'Dự toán ngân sách',
    buPlanReceipt: 'Nhận dự toán',
    buPlanCancel: 'Hủy dự toán',
    diBudgetChapter: 'Chương',
    diBudgetProvide: 'Mã dự phòng',
    diFund: 'Quỹ tiền',
    diReceipt: 'Mẫu số biên lai',
    diAsset: 'Tài sản',
    diAssetCategory: 'Loại tài sản',
    diListCode: 'Mã thống kê',
    diJusticeCase: 'Bản án',
    diJusticeCaseType: 'Loại bản án',
    diJusticeDecision: 'Quyết định thi hành án',
    diJusticeDecisionGroup: 'Nhóm quyết định thi hành án',
    diAccountObjectMasterList: 'Danh sách đối tượng',
    diCurrency: 'Loại tiền tệ',
    diBankInfo: 'Tài khoản ngân hàng',
    diBankStandard: 'Ngân hàng/Kho bạc',
    diBankStandardList: 'Ngân hàng/Kho bạc',
    diAccount: 'Tài khoản',
    diAccountingObject: 'Đối tượng',
    diAccountTransfer: 'Tài khoản kết chuyển',
    diBranch: 'Đơn vị',
    diArea: 'Khu vực',
    dictionaryArea: 'Khu vực',
    userManagement: 'Người dùng'
  },
  // Các cột thường dùng
  CommonColumn: {
    RefNo: 'Số CT',
    RefNoTooltip: 'Số chứng từ',
    RefDate: 'Ngày CT',
    RefDateTooltip: 'Ngày chứng từ',
    AccountingDate: 'Ngày HT',
    Description: 'Diễn giải',
    FullName: 'Họ tên',
    Address: 'Địa chỉ',
    Currency: 'Loại tiền',
    DecisionDate: 'Ngày QĐ',
    DecisionDateTooltip: 'Ngày quyết định',
    DecisionNo: 'Số QĐ',
    DecisionNoTooltip: 'Số quyết định',
    BuPlanTitle: 'Thuộc dự toán',
  },
  // Label của các combobox hay dùng config chung ở đây
  LabelCombobox: {
    Fund: 'Quỹ tiền',
    BudgetKindItem: 'Khoản',
    Year: 'Năm',
    ProjectXDCB: 'Dự án, Công trình, HMCT',
    ProjectXDCBTooltip: 'Dự án, Công trình, Hạng mục công trình',
    ReportPeriod: 'Kỳ báo cáo',
    FromMonth: 'Từ tháng',
    ToMonth: 'Đến tháng',
    Month: 'Tháng',
    CompareType: 'Đối chiếu theo',
    Quater: 'Quý',
    BudgetSource: 'Nguồn',
    BudgetChapter: 'Chương',
    Project: 'CTMT, DA',
    ProjectTooltip: 'Chương trình mục tiêu, dự án',
  },

  // Title của các popup hay dùng config chung ở đây
  PopupTitle: {
    ReportParam: 'Tham số báo cáo',
    ComparisonReportTemplate: 'Mẫu báo cáo đối chiếu',
  },
  Report:{ 
    PeriodLabel: 'Chọn kỳ báo cáo',
    PeriodLabelCustom: 'Kỳ',
    FromLabel: 'Từ ngày',
    ToLabel: 'Đến ngày'
  }
};
